import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ChevronDown, Phone, Mail } from "lucide-react";
const Navbar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [academicOpen, setAcademicOpen] = useState(false);
  const [studentOpen, setStudentOpen] = useState(false);
  const [committeeOpen, setCommitteeOpen] = useState(false);
  const [mobileCommitteeOpen, setMobileCommitteeOpen] = useState(false);
  useEffect(() => {
    document.body.style.overflow = mobileMenu ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [mobileMenu]);
  const closeMenu = () => setMobileMenu(false);
  const navLink =
    "relative text-[13px] font-bold uppercase tracking-wider text-[#0B1F5C] hover:text-[#D4A017] transition-all duration-300 flex items-center gap-1 py-2";
  const dropdownItem =
    "block px-5 py-3 text-sm font-semibold text-[#0B1F5C] hover:bg-[#0B1F5C] hover:text-white transition-all border-b border-gray-100";
  const mobileLink =
    "block w-full py-3.5 px-4 rounded-xl border border-gray-100 bg-[#F8FAFC] font-bold text-sm text-[#0B1F5C] hover:bg-[#0B1F5C] hover:text-white transition-all";
  return (
    <>
      <div className="bg-[#0B1F5C] text-white">
        <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center text-xs md:text-sm">
          <div className="flex items-center gap-4">
            <a href="tel:+917080100321" className="flex items-center gap-2">
              <Phone size={14} className="text-[#FFD700]" />
              <span>+91-9451887217</span>
            </a>
            <a
              href="mailto:psndwivedi@gmail.com"
              className="hidden md:flex items-center gap-2"
            >
              <Mail size={14} className="text-[#FFD700]" />
              <span>psndwivedi@gmail.com</span>
            </a>
          </div>
          <Link
            to="/ugc-committee"
            className="bg-[#D4A017] text-[#0B1F5C] px-3 md:px-4 py-1.5 md:py-2 text-[10px] md:text-[11px] font-black rounded-md"
          >
            UGC Committee
          </Link>
        </div>
      </div>
      <nav className="sticky top-0 z-50 bg-white border-b-[3px] border-[#D4A017] shadow-md">
        <div className="max-w-7xl mx-auto px-4 lg:px2">
          <div className="flex justify-between items-center h-[78px] md:h-[90px]">
            <Link to="/" className="flex items-center gap-2 md:gap-3">
              <img
                src="/logo.png"
                alt="College Logo"
                className="h-20 w-20 md:h-24 md:w-24 object-contain shrink-0"
              />
              <div className="flex flex-col leading-tight">
                <h1 className="text-[#0B1F5C] font-extrabold text-[12px] sm:text-[14px] md:text-[17px]">
                  Pt. Shrinivas Dwivedi Mahavidyalaya
                </h1>
                <p className="text-[#D4A017] text-[9px] sm:text-[10px] md:text-[12px] font-medium">
                  Arangi, Chandauli (U.P.)
                </p>
                <p className="text-[#102C57] text-[8px] sm:text-[9px] md:text-[11px]">
                  Affiliated to M. G. Kashi Vidyapith
                </p>
              </div>
            </Link>
            <div className="hidden lg:flex items-center gap-7">
              <Link to="/" className={navLink}>
                HOME
              </Link>
              <div
                className="relative"
                onMouseEnter={() => setAboutOpen(true)}
                onMouseLeave={() => setAboutOpen(false)}
              >
                <button className={navLink}>
                  ABOUT{" "}
                  <ChevronDown
                    size={14}
                    className={aboutOpen ? "rotate-180 text-[#D4A017]" : ""}
                  />
                </button>
                <div
                  className={`absolute left-0 top-full w-60 bg-white shadow-2xl border-t-4 border-[#0B1F5C] rounded-b-xl overflow-hidden transition-all duration-300 ${
                    aboutOpen ? "opacity-100 visible" : "opacity-0 invisible"
                  }`}
                >
                  <Link to="/about-college" className={dropdownItem}>
                    About College
                  </Link>
                  <Link to="/principal-message" className={dropdownItem}>
                    Principal Message
                  </Link>
                </div>
              </div>
              <div
                className="relative"
                onMouseEnter={() => setAcademicOpen(true)}
                onMouseLeave={() => setAcademicOpen(false)}
              >
                <button className={navLink}>
                  ACADEMICS{" "}
                  <ChevronDown
                    size={14}
                    className={
                      academicOpen ? "rotate-180 text-[#D4A017]" : ""
                    }
                  />
                </button>
                <div
                  className={`absolute left-0 top-full w-60 bg-white shadow-2xl border-t-4 border-[#0B1F5C] rounded-b-xl overflow-hidden transition-all duration-300 ${
                    academicOpen ? "opacity-100 visible" : "opacity-0 invisible"
                  }`}
                >
                  <Link to="/facilities" className={dropdownItem}>
                    College Facilities
                  </Link>
                </div>
              </div>
              <Link to="/activity" className={navLink}>
                ACTIVITIES
              </Link>
               <div
              className="relative"
              onMouseEnter={() => setCommitteeOpen(true)}
              onMouseLeave={() => setCommitteeOpen(false)}
            >
              <button className={navLink}>
                COMMITTEES
                <ChevronDown
                  size={14}
                  className={committeeOpen ? "rotate-180 text-[#D4A017]" : ""}
                />
              </button>

              <div
                className={`absolute left-0 top-full w-72 bg-white shadow-2xl border-t-4 border-[#0B1F5C] rounded-b-xl overflow-hidden transition-all duration-300 ${
                  committeeOpen
                    ? "opacity-100 visible"
                    : "opacity-0 invisible"
                }`}
              >
        <Link to="/anti-ragging" className={dropdownItem}>
          Anti Ragging Committee
        </Link>

          <Link to="/sexual-harassment-cell" className={dropdownItem}>
            Sexual Harassment Cell
          </Link>

          <Link to="/internal-complaints-committee" className={dropdownItem}>
            Internal Complaints Committee
          </Link>

          <Link to="/student-grievance-redressal" className={dropdownItem}>
            Student Grievance Redressal Committee
          </Link>

          <Link to="/rti-nodal-officer" className={dropdownItem}>
            RTI Nodal Officer
          </Link>

          <Link to="/iqac" className={dropdownItem}>
            Internal Quality Assurance Cell (IQAC)
          </Link>

          <Link to="/other-cells" className={dropdownItem}>
            Fee-Refund-Policy
          </Link>
          </div>
           </div>
              <Link to="/gallery" className={navLink}>
                GALLERY
              </Link>
              <div
                className="relative"
                onMouseEnter={() => setStudentOpen(true)}
                onMouseLeave={() => setStudentOpen(false)}
              >
                <button className={navLink}>
                  STUDENT{" "}
                  <ChevronDown
                    size={14}
                    className={
                      studentOpen ? "rotate-180 text-[#D4A017]" : ""
                    }
                  />
                </button>
                <div
                  className={`absolute left-0 top-full w-56 bg-white shadow-2xl border-t-4 border-[#0B1F5C] rounded-b-xl overflow-hidden transition-all duration-300 ${
                    studentOpen ? "opacity-100 visible" : "opacity-0 invisible"
                  }`}
                >
                  <Link to="/transfer" className={dropdownItem}>
                    Transfer Certificate
                  </Link>
                </div>
              </div>
              <Link to="/contact" className={navLink}>
                CONTACT
              </Link>
              <Link
                to="/enquiry"
                className="bg-[#0B1F5C] text-[#FFD700] px-5 py-2 text-[11px] font-black rounded-md"
              >
                Enquiry Form
              </Link>
            </div>
            <button
              className="lg:hidden bg-[#0B1F5C] text-white p-2 rounded-md"
              onClick={() => setMobileMenu(true)}
              aria-label="Open Menu"
            >
              <Menu size={22} />
            </button>
          </div>
        </div>
        <div
          className={`lg:hidden fixed inset-0 z-[999] transition-all duration-300 ${
            mobileMenu ? "visible opacity-100" : "invisible opacity-0"
          }`}
        >
          <div
            className="absolute inset-0 bg-black/45"
            onClick={closeMenu}
          ></div>
          <div
            className={`absolute right-0 top-0 h-full w-[86%] max-w-[360px] bg-white shadow-2xl transition-transform duration-300 ${
              mobileMenu ? "translate-x-0" : "translate-x-full"
            }`}
          >
            <div className="bg-[#0B1F5C] text-white p-5">
              <div className="flex justify-between items-start gap-3">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-white rounded-full p-1 flex items-center justify-center">
                    <img
                      src="/logo.png"
                      alt="College Logo"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div>
                    <h2 className="text-sm font-black leading-tight">
                      मं. कमवार डिग्री महाविद्यालय
                    </h2>
                    <p className="text-[#FFD700] text-xs mt-1">
                      अरंगी, चन्दौली
                    </p>
                  </div>
                </div>
                <button
                  onClick={closeMenu}
                  className="bg-white/10 p-2 rounded-lg"
                  aria-label="Close Menu"
                >
                  <X size={22} />
                </button>
              </div>
            </div>
            <div className="h-[calc(100vh-92px)] overflow-y-auto p-5">
              <div className="space-y-3">
                <Link to="/" onClick={closeMenu} className={mobileLink}>
                  HOME
                </Link>
                <Link
                  to="/about-college"
                  onClick={closeMenu}
                  className={mobileLink}
                >
                  ABOUT COLLEGE
                </Link>
                <Link
                  to="/principal-message"
                  onClick={closeMenu}
                  className={mobileLink}
                >
                  PRINCIPAL MESSAGE
                </Link>
                <Link
                  to="/facilities"
                  onClick={closeMenu}
                  className={mobileLink}
                >
                  COLLEGE FACILITIES
                </Link>
                <Link
                  to="/activity"
                  onClick={closeMenu}
                  className={mobileLink}
                >
                  ACTIVITIES
                </Link>


              <div>
                <button
                  onClick={() => setMobileCommitteeOpen(!mobileCommitteeOpen)}
                  className={`${mobileLink} flex justify-between items-center`}
                >
                  COMMITTEES
                  <ChevronDown
                    size={18}
                    className={`transition-transform ${
                      mobileCommitteeOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {mobileCommitteeOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    <Link
                      to="/anti-ragging"
                      onClick={closeMenu}
                      className={mobileLink}
                    >
                      Anti Ragging Committee
                    </Link>

                    <Link
                      to="/sexual-harassment-cell"
                      onClick={closeMenu}
                      className={mobileLink}
                    >
                      Sexual Harassment Cell
                    </Link>

                    <Link
                      to="/internal-complaints-committee"
                      onClick={closeMenu}
                      className={mobileLink}
                    >
                      Internal Complaints Committee
                    </Link>

                    <Link
                      to="/student-grievance-redressal"
                      onClick={closeMenu}
                      className={mobileLink}
                    >
                      Student Grievance Redressal Committee
                    </Link>

                    <Link
                      to="/rti-nodal-officer"
                      onClick={closeMenu}
                      className={mobileLink}
                    >
                      RTI Nodal Officer
                    </Link>

                    <Link
                      to="/iqac"
                      onClick={closeMenu}
                      className={mobileLink}
                    >
                      IQAC
                    </Link>

                    <Link
                      to="/other-cells"
                      onClick={closeMenu}
                      className={mobileLink}
                    >
                      Fee-Refund-Policy
                    </Link>
                  </div>
                )}
              </div>

                <Link
                  to="/gallery"
                  onClick={closeMenu}
                  className={mobileLink}
                >
                  GALLERY
                </Link>

                
                <Link
                  to="/student/tc"
                  onClick={closeMenu}
                  className={mobileLink}
                >
                  TRANSFER CERTIFICATE
                </Link>
                <Link
                  to="/contact"
                  onClick={closeMenu}
                  className={mobileLink}
                >
                  CONTACT
                </Link>

                <Link
                  to="/enquiry"
                  onClick={closeMenu}
                  className="block w-full text-center bg-[#0B1F5C] text-[#FFD700] py-3.5 px-4 rounded-xl font-black text-sm shadow-md"
                >
                  ENQUIRY FORM
                </Link>
              </div>
              <div className="mt-6 rounded-2xl bg-[#F8FAFC] border border-gray-100 p-4">
                <a
                  href="tel:+917080100321"
                  className="flex items-center gap-2 text-[#0B1F5C] font-bold text-sm"
                >
                  <Phone size={16} className="text-[#D4A017]" />
                  +91-9451887217
                </a>
                <a
                  href="mailto:psndwivedi@gmail.com"
                  className="flex items-center gap-2 text-[#0B1F5C] font-bold text-sm mt-3 break-all"
                >
                  <Mail size={16} className="text-[#D4A017]" />
                  psndwivedi@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
export default Navbar;